@if (displayEditPanel) {
    <div class="card panel-flat-color primary-panel document-processing-entity-edit-panel">
        <div class="panel-flat-header">
            <h3>Entity Edit</h3>
        </div>
        @if (associatedEntityChanged && !verifiedChangedEntity) {
            <div
                class="panel-flat-body"
                style="padding: 20px; overflow: initial;">
                <p>
                    The entity this document is associated with has changed since the association
                    was made. You will not be able to complete this task until the entity is
                    reloaded.
                </p>
                <button type="button" class="ace-btn btn-secondary" (click)="verifyChangedEntity()">OK</button>
            </div>
        }
        @if (!associatedEntityChanged || verifiedChangedEntity) {
            <div class="panel-flat-body"
                 style="padding: 20px; overflow: initial;">
                <!-- Check for attachmentModalData.entityName since it loads from the entity tree, whereas the rest
                loads from the entity edit panel, and both must be loaded for this to work -->
                @if (shouldShowConfidencePanel) {
                    <idp-confidence-details [currentDocument]="intakeDocumentInfo"
                                            [billDetail]="billVM"
                                            [assessmentDetail]="assessmentVM"
                                            (idpAcceptedBill)="idpAcceptedBill($event)"
                                            (idpAcceptedAssessmentDetail)="idpAcceptedAssessment($event)"
                                            [assessmentChild]="assessmentChild"
                                            [disableApplyAll]="disableApplyAll"
                                            [mappingExplanations]="mappingExplanations"
                                            [isLowConfidence]="isLowConfidence">
                    </idp-confidence-details>
                }
                @if (genericEntityVM && genericEntityVM.attachmentModalData.entityName) {
                    <div class="float-end">
                        <entity-attachments [(hasAttachments)]="genericEntityVM.hasAttachments"
                                            buttonClass="has-icon"
                                            [modalData]="genericEntityVM.attachmentModalData">
                        </entity-attachments>
                        <entity-comments [(hasComments)]="genericEntityVM.hasComments"
                                         buttonClass="has-icon"
                                         [modalData]="genericEntityVM.commentModalData">
                        </entity-comments>
                    </div>
                }
                @if (genericEntityVM) {
                    <div class="mb-3" style="margin-top:2em;">
                        <label>Year</label>
                        <select class="form-select form-select-sm" [(ngModel)]="year">
                            <option value=""></option>
                            @for (y of years; track y) {
                                <option>{{ y }}</option>
                            }
                        </select>
                    </div>
                }
                <appeal [viewModel]="appealVM"
                        [editState]="editState"
                        [taskReadonly]="true"
                        [hideDelete]="true"
                        [isDocumentProcessing]="true">
                </appeal>
                <compliance
                    [viewModel]="complianceVM"
                    [editState]="editState"
                    [companyId]="companyId"
                    [taskReadonly]="true"
                    [hideDelete]="true"
                    [isDocumentProcessing]="true">
                </compliance>
                <bills [viewModel]="billVM"
                       [editState]="editState"
                       [showExtraFields]="showExtraBillFields"
                       [stateId]="stateId"
                       [isDocumentProcessing]="true"
                       [processingParcelTaxSetup]="parcelChanges && parcelChanges.newTaxSetup"
                       [firstEncounterSavedCallback]="wrappedFirstEncounterSavedCallback"
                       [hasProcessingChanges]="dataEntryChanged"
                       [collector]="collector"
                       (RevisionChanged)="billRevisionChangedX.emit($event)">
                </bills>
                <refund [viewModel]="refundVM"
                        [editState]="editState"
                        [isDocumentProcessing]="true">
                </refund>
                <assessment #assessmentChild
                            [viewModel]="assessmentVM"
                            [editState]="editState"
                            [taskReadonly]="true"
                            [compactMode]="true"
                            [isDocumentProcessing]="true"
                            [viewTaxableValues]="viewTaxableValues"
                            [isIDP]="shouldShowConfidencePanel">
                </assessment>
                <div class="entity-edit-footer mb-3">
                    <label>Attachment Description</label>
                    <textarea class="form-control" [(ngModel)]="attachmentDescription"></textarea>
                    @if (isReadyTaskAnticipated) {
                        <div class="checkbox">
                            <label>
                                <input type="checkbox"
                                       [(ngModel)]="completeReadyTask"
                                       (change)="onCompleteReadyTaskChange()"/>
                                At completion of document processing mark the {{ entityTypeName }}'s {{ readyTaskName }}
                                task COMPLETE.
                            </label>
                        </div>
                    }
                    @if (isReadyTaskReviewBill) {
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" [(ngModel)]="useDocumentAsBillImage"/> Use document as bill image
                            </label>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}
